import { render, staticRenderFns } from "./RulesCard.vue?vue&type=template&id=a6592fcc&scoped=true&lang=pug&"
import script from "./RulesCard.vue?vue&type=script&lang=js&"
export * from "./RulesCard.vue?vue&type=script&lang=js&"
import style0 from "./RulesCard.vue?vue&type=style&index=0&id=a6592fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6592fcc",
  null
  
)

export default component.exports